import React, { Component } from 'react';
import { Form, Input, Mentions, Button } from 'antd';

const FormItem = Form.Item;

class DetailedScheduleEditCommentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: props.editValue,
            labelValue: props.labelValue === "myTourComment" ? "My Tour Comment" 
                : props.labelValue === "myDayComment" ? "My Day Comment"
                : props.labelValue === "myAssignComment" ? "My Assignment Comment" : "Comment",
            maxLength: props.labelValue === "myDayComment" ? 1000 : 8000 // Needs to be updated when assignments is added
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.handleComponentEditSubmit(this.state.comment, this.props.labelValue);
    }

    handleChange = ({target: {value}}) => {
        this.setState({ comment: value.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g,'') });
    }

    handleCancel = () => {
        this.props.handleEditCancel();
    }

    render() {
        return(
            <Form onSubmit={this.handleSubmit}>
                <FormItem>
                    <div>
                        <Mentions 
                            style={{ marginRight: 10, border: "none", width: 200 }}
                            defaultValue={this.state.labelValue}
                            readOnly
                        />
                        <Input.TextArea 
                            value={this.state.comment}
                            onChange={this.handleChange}
                            onKeyUp={this.handleChange}
                            name="commentEdit"
                            id="commentEdit"
                            allowClear
                            maxLength={this.state.maxLength}
                            rows='5'
                        />
                    </div>
                </FormItem>
                <FormItem>
                    <div>
                        <Button type="danger" onClick={this.handleCancel}>Cancel</Button>
                        <Button 
                            type="primary" 
                            htmlType="submit"
                            disabled={this.props.buttonDisable}
                        >
                            Submit
                        </Button>
                    </div>
                </FormItem>
            </Form>
        );
    }
}

export const WrappedDetailedScheduleEditCommentForm = Form.create()(DetailedScheduleEditCommentForm);


// WEBPACK FOOTER //
// ./src/Components/Schedule/DetailedSchedule/DetailedScheduleEditCommentForm.js